/* MDP-4: ONE address formatter for everywhere addresses render (hero, cards,
   OG images). Dedupes repeated segments — OSM rows often have city===district,
   which used to render "Mehdipatnam, Hyderabad, Hyderabad, Telangana". */

export function formatAddress(...parts: Array<string | null | undefined>): string {
  const seen = new Set<string>()
  const out: string[] = []
  for (const raw of parts) {
    /* split comma-joined parts too — addressLine1 is often "Wakad, Pune" while
       district/city repeat "Pune", which previously rendered
       "Wakad, Pune, Pune, Maharashtra". Dedupe at the segment level. */
    for (const seg of String(raw || '').split(',')) {
      const part = seg.trim()
      if (!part) continue
      const key = part.toLowerCase()
      if (seen.has(key)) continue
      seen.add(key)
      out.push(part)
    }
  }
  return out.join(', ')
}
